module.exports = __webpack_public_path__ + "static/media/rebirth_12.4874b668.jpg";